export enum ChannelAppType {
    WEB = 1,
    WEB_APP = 2,
    MOBILE = 3,
}
